// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ utilities
const { formatText, FormattedText} = require('core/i18n').i18n;

// @components
const OpenYoungCardExpensesGraph = require('./openYoungCardExpensesGraph/openYoungCardExpensesGraph');

class OpenYoungCardExpenses extends React.Component {
    constructor(props){
        super(props);
        this.onHandleSetFilter = this.onHandleSetFilter.bind(this);
    }

    onHandleSetFilter(filters) {
        this.props.setExpenseFilter(filters);
        this.props.getExpenseDetails();
    }

    render(){
        const { openYoungCardExpenses, getExpenseDetails, cardId } = this.props;
        let content;
        if(openYoungCardExpenses.get('getExpenseListFetch')) {
            content = (
                <LoadingSection />
            );
        } else if(openYoungCardExpenses.get('getExpenseListError')) {
            const retryButton = (
                <OKButton
                    modifier="link-complementary"
                    onClick={getExpenseDetails}
                >
                    <FormattedText value="openYoungCardExpenses-retryLink" />
                </OKButton>
            );

            content = (
                <EmptyState
                    primaryText={formatText('openYoungCardExpenses-connectionFailureMessage')}
                    secondaryText={formatText('openYoungCardExpenses-connectionFailureSubMessage')}
                    button={retryButton}
                    iconType="nointernet-banking" />
            );
        }
        else {
            content = (
                <OpenYoungCardExpensesGraph
                    cardId={cardId}
                    immExpenses={openYoungCardExpenses.get('expenses')}
                    immFilters={openYoungCardExpenses.get('filters')}
                    handleSetFilter={this.onHandleSetFilter}
                />
            );
        }
        return content;
    }
}

OpenYoungCardExpenses.propTypes = {
    cardId: PropTypes.string.isRequired,
    getExpenseDetails: PropTypes.func,
    immCards: PropTypes.object,
    openYoungCardExpenses: PropTypes.object,
    setExpenseFilter: PropTypes.func
};
module.exports = OpenYoungCardExpenses;
